import React from 'react';

export default function WatchStar({ watched, onToggle }) {
  return (
    <button
      onClick={onToggle}
      title={watched ? 'Rimuovi dalla watchlist' : 'Aggiungi alla watchlist'}
      style={{
        fontSize: 20, lineHeight: 1, cursor: 'pointer', background: 'transparent',
        border: 'none', padding: '2px 6px',
        color: watched ? '#fbbf24' : '#475569',
      }}
      onMouseEnter={e => { if (!watched) e.currentTarget.style.color = '#94a3b8'; }}
      onMouseLeave={e => { if (!watched) e.currentTarget.style.color = '#475569'; }}>
      {watched ? '★' : '☆'}
    </button>
  );
}
